import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TranslateModule } from '@ngx-translate/core';
import { faPlus, faTrash, faTimes } from '@fortawesome/free-solid-svg-icons';
import { ClassificationItem } from '../../services/models.service';

@Component({
  selector: 'app-classification-config',
  standalone: true,
  imports: [FormsModule, FontAwesomeModule, TranslateModule],
  templateUrl: './classification-config.component.html',
  styleUrls: ['./classification-config.component.scss']
})
export class ClassificationConfigComponent implements OnChanges {
  @Input() initialValue: ClassificationItem[] = [];
  @Input() readonly = false;
  @Output() valueChange = new EventEmitter<ClassificationItem[]>();

  items: ClassificationItem[] = [];
  exampleInputs: string[] = [];

  faPlus = faPlus;
  faTrash = faTrash;
  faTimes = faTimes;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['initialValue']) {
      this.items = this.initialValue
        ? this.initialValue.map(i => ({ ...i, examples: [...(i.examples || [])] }))
        : [];
      this.exampleInputs = this.items.map(() => '');
    }
  }

  addItem(): void {
    this.items.push({ id: '', description: '', examples: [] });
    this.exampleInputs.push('');
    this.emit();
  }

  removeItem(index: number): void {
    this.items.splice(index, 1);
    this.exampleInputs.splice(index, 1);
    this.emit();
  }

  onFieldChange(): void {
    this.emit();
  }

  addExample(itemIndex: number, raw: string): void {
    const value = raw.trim().replace(/,+$/, '').trim();
    if (!value) return;
    if (!this.items[itemIndex].examples.includes(value)) {
      this.items[itemIndex].examples.push(value);
      this.emit();
    }
    this.exampleInputs[itemIndex] = '';
  }

  removeExample(itemIndex: number, exampleIndex: number, event: Event): void {
    event.stopPropagation();
    this.items[itemIndex].examples.splice(exampleIndex, 1);
    this.emit();
  }

  onExampleKeydown(event: KeyboardEvent, itemIndex: number): void {
    if (event.key === 'Enter' || event.key === ',') {
      event.preventDefault();
      this.addExample(itemIndex, this.exampleInputs[itemIndex]);
    } else if (
      event.key === 'Backspace' &&
      !this.exampleInputs[itemIndex] &&
      this.items[itemIndex].examples.length > 0
    ) {
      this.items[itemIndex].examples.pop();
      this.emit();
    }
  }

  trackByIndex(index: number): number {
    return index;
  }

  private emit(): void {
    this.valueChange.emit(this.items.map(i => ({ ...i, examples: [...i.examples] })));
  }
}
